/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DocumentStampedV2Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The id of the ticket
   */
  ticketId: string;
  /**
   * Cost center of the stamped document
   */
  costCenter: string;
  /**
   * General ledger account
   */
  generalLeaderAccount: string;
  /**
   * General ledger account number
   */
  generalLeaderAccountNr: string;
  /**
   * One-time contribution amount
   */
  oneTimeContribution: number;
  /**
   * Approval number
   */
  approvalNr: string;
  /**
   * Amount
   */
  amount: number;
  /**
   * Interval (e.g., monthly, yearly)
   */
  interval: number;
  /**
   * Name of the first reviewer
   */
  reviewer1Name: string;
  /**
   * Date of the first review
   */
  reviewer1Date: string;
  /**
   * Name of the second reviewer
   */
  reviewer2Name?: string | null;
  /**
   * Date of the second review
   */
  reviewer2Date?: string | null;
  /**
   * Indicates if this is a recurring payment
   */
  recurringPayment: boolean;
  /**
   * Indicates if this is a back payment
   */
  backPayment: boolean;
  /**
   * The currency of the payment.
   */
  currency: DocumentStampedV2Dto.currency;
  /**
   * The uuid of the document. As 8-4-4-4-12 format.
   */
  documentId: string;
};
export namespace DocumentStampedV2Dto {
  /**
   * The currency of the payment.
   */
  export enum currency {
    EUR = 'EUR',
    ALL = 'ALL',
    AMD = 'AMD',
    AZN = 'AZN',
    BYN = 'BYN',
    BAM = 'BAM',
    CZK = 'CZK',
    DKK = 'DKK',
    GEL = 'GEL',
    GIP = 'GIP',
    GGP = 'GGP',
    HUF = 'HUF',
    ISK = 'ISK',
    IMP = 'IMP',
    JEP = 'JEP',
    KZT = 'KZT',
    CHF = 'CHF',
    MDL = 'MDL',
    MKD = 'MKD',
    NOK = 'NOK',
    PLN = 'PLN',
    RON = 'RON',
    RUB = 'RUB',
    RSD = 'RSD',
    SEK = 'SEK',
    TRY = 'TRY',
    UAH = 'UAH',
    GBP = 'GBP',
  }
}
